<template>
  <div>
    <Title :title="title" :level="2" class="title-size-cleed" />
    <Title :title="brandProduct" :level="brandProductSize" class="title-size-cleed" :style="colorBrandProduct" />
  </div>
</template>
<script>
import Title from "@/components/modal/ui/Title.vue";

export default {

  name: "TwoTitle",
  components: {
    Title,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    brandProduct: {
      type: String,
      default: "",
    },
    brandProductSize: {
      type: Number,
      default: 3,
    },
    colorBrandProduct: {
      type: String,
      default: "color: gray;",
    },
  },
};
</script>
